import React, { useState } from "react";
import { Pressable, Text, View } from "react-native";
import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const NARRATION_BY_COMPARISON_ID = Object.freeze({
  math_clock: "jagged_math_clock",
  agent_physical: "jagged_agent_physical",
  simulation_real: "jagged_simulation_real",
});
import { getAIExhibitCurrentStatus } from "../content/aiExhibitCurrentStatus";
import { getAIExhibitBatch4Copy } from "../content/aiExhibitBatch4Content";

export default function JaggedFrontierScreen({
  language="en",
  audioEnabled=false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t=getAIExhibitBatch4Copy(language).jagged;
  const items=getAIExhibitCurrentStatus(language).jaggedComparisons;
  const [index,setIndex]=useState(0); const [choice,setChoice]=useState(null); const [revealed,setRevealed]=useState(false);
  const item=items[index]; const correct=choice===item.harder;
  const next=()=>{setIndex((x)=>(x+1)%items.length);setChoice(null);setRevealed(false)};
  return <View style={{padding:28}}>
    <Text style={{color:C.accent,fontSize:13,fontWeight:"900",letterSpacing:1.2}}>{t.eyebrow}</Text>
    <Text style={{color:C.text,fontSize:44,lineHeight:50,fontWeight:"900",marginTop:8}}>{t.title}</Text>
    <Text style={{color:C.muted,fontSize:18,lineHeight:27,marginTop:8,maxWidth:960}}>{t.subtitle}</Text>
    <View style={{marginTop:24,padding:22,borderRadius:19,borderWidth:1,borderColor:C.border,backgroundColor:C.surfaceRaised}}>
      <Text style={{color:C.muted,fontSize:13,fontWeight:"900"}}>{index+1} / {items.length}</Text>
      <Text style={{color:C.text,fontSize:20,fontWeight:"900",marginTop:8}}>{t.chooseHarder}</Text>
      <View style={{flexDirection:"row",flexWrap:"wrap",gap:14,marginTop:16}}>
        {["left","right"].map((side)=>{const active=choice===side;const o=item[side];return <Pressable key={side} onPress={()=>{setChoice(side);setRevealed(false)}} style={({pressed})=>({flex:1,minWidth:330,minHeight:185,padding:22,borderRadius:18,borderWidth:active?3:1,borderColor:active?C.accent:C.border,backgroundColor:active||pressed?C.accentSoft:C.surface,alignItems:"center",justifyContent:"center"})}>
          <Text style={{fontSize:44}}>{o.icon}</Text><Text style={{color:C.text,fontSize:21,lineHeight:29,fontWeight:"900",textAlign:"center",marginTop:12}}>{o.title}</Text>
        </Pressable>})}
      </View>
      <Pressable disabled={!choice} onPress={()=>{
        setRevealed(true);
        playNarration(NARRATION_BY_COMPARISON_ID[item.id]);
      }} style={({pressed})=>({marginTop:16,alignSelf:"flex-start",minHeight:52,paddingHorizontal:18,paddingVertical:12,borderRadius:14,borderWidth:1,borderColor:C.accent,backgroundColor:pressed?C.surface:C.accentSoft,opacity:choice?1:.4})}><Text style={{color:C.text,fontSize:16,fontWeight:"900"}}>{t.reveal}</Text></Pressable>
      {revealed?<View style={{marginTop:18,padding:18,borderRadius:16,borderLeftWidth:5,borderWidth:1,borderColor:C.border,borderLeftColor:correct?C.success:C.warning,backgroundColor:C.accentSoft}}>
        <Text style={{color:correct?C.success:C.warning,fontSize:13,fontWeight:"900"}}>{(correct?t.right:t.surprise).toUpperCase()}</Text>
        <Text style={{color:C.text,fontSize:24,lineHeight:31,fontWeight:"900",marginTop:7}}>{item.revealTitle}</Text>
        <Text style={{color:C.text,fontSize:16,lineHeight:26,marginTop:9}}>{item.reveal}</Text>
        <Text style={{color:C.muted,fontSize:12,marginTop:10}}>{item.sourceLabel}</Text>
        <Pressable onPress={next} style={({pressed})=>({marginTop:16,alignSelf:"flex-start",minHeight:50,paddingHorizontal:16,paddingVertical:11,borderRadius:13,borderWidth:1,borderColor:C.border,backgroundColor:pressed?C.surfaceRaised:C.surface})}><Text style={{color:C.text,fontSize:15,fontWeight:"900"}}>{t.next} →</Text></Pressable>
      </View>:null}
    </View>
    <AIExhibitNarrationPressable
      audioEnabled={audioEnabled}
      onPress={() => playNarration("jagged_lasting_lesson")}
      style={{marginTop:16,padding:18,borderRadius:16,borderWidth:1,borderColor:C.border,backgroundColor:C.surfaceRaised}}
    ><Text style={{color:C.text,fontSize:17,lineHeight:26,fontWeight:"800"}}>{t.lasting}</Text></AIExhibitNarrationPressable>
  </View>;
}
